import { createReducer, on } from "@ngrx/store";
import { initialParametrosGeneralesState } from "../../core/interfaces/models/parametrosGenerales.interface";
import { addParametrosGenerales, addParametrosGeneralesError, clearParametrosGenerales } from "../actions/parametrosGenerales.actions";

export const parametrosGeneralesReducer = createReducer(
  initialParametrosGeneralesState,
    on(addParametrosGenerales, (_, { parametrosGeneralesState }) => (
      parametrosGeneralesState
    )),
    
    on(addParametrosGeneralesError, (state) => ({
      ...state,
      error: true,
    })), 
  
    on(clearParametrosGenerales, () => initialParametrosGeneralesState)

  /*
  on(addParametrosGenerales, (state, { parametrosGenerales }) => ({
    ...state,
    parametrosGenerales: parametrosGenerales,
  })),

  on(deleteParametrosGenerales, () => initialParametrosGeneralesState),

    on(addParametrosGeneralesError, (state) => ({
      ...state,
      error: true,
    })),
  
    on(deleteParametrosGeneralesError, (state) => ({
      ...state,
      error: false,
    })),
  
  
    on(updateParametrosGenerales, (state, { parametrosGenerales }) => ({
      ...state,
      parametrosGenerales: parametrosGenerales
    })),*/
);

